import { useState } from 'react'
import TouchSide from '../assets/touch-side-icon.svg'
const ContactSection = () => {
  const [email, setEmail] = useState('')
  const [fullName, setFullName] = useState('')
  const [message, setMessage] = useState('')
  return (
    <div className='flex flex-col min-[1600px]:flex-row items-start justify-between w-full py-8 lg:py-16 px-4 sm:px-6 lg:px-20'>
      <div className='w-full flex flex-col justify-start items-start min-[1600px]:pr-36'>
        <div className='text-[#181D27] text-[32px] lg:text-[64px] font-[700]'>
          Get in Touch With Us
        </div>
        <div className='text-[#535862] text-[14px] lg:text-[16px] font-[500] text-start'>
          We&apos;re here to help you every step of the way. Whether you have
          questions about filing, need technical support, or just want to learn
          more about our services, our team is always ready to assist.
        </div>
        <div className='flex flex-col items-start justify-center w-full mt-10'>
          <div className='flex flex-col items-start justify-center w-full'>
            <label
              htmlFor='email'
              className='block text-sm font-medium text-gray-700 mb-2'
            >
              Email
            </label>
            <input
              type='email'
              id='email'
              value={email}
              onChange={e => setEmail(e.target.value)}
              className='w-full px-3 py-3 border border-gray-300 rounded-lg text-black outline-none'
            />
          </div>
          <div className='flex flex-col items-start justify-center w-full mt-4'>
            <label
              htmlFor='email'
              className='block text-sm font-medium text-gray-700 mb-2'
            >
              Full Name
            </label>
            <input
              type='text'
              id='fullName'
              value={fullName}
              onChange={e => setFullName(e.target.value)}
              className='w-full px-3 py-3 border border-gray-300 rounded-lg text-black outline-none'
            />
          </div>
          <div className='flex flex-col items-start justify-center w-full mt-4'>
            <label
              htmlFor='email'
              className='block text-sm font-medium text-gray-700 mb-2'
            >
              Messages
            </label>
            <textarea
              id='message'
              rows={4}
              value={message}
              onChange={e => setMessage(e.target.value)}
              placeholder='Enter message here'
              className='w-full px-3 py-3 border border-gray-300 rounded-lg text-black outline-none resize-none'
            />
            <div className='flex flex-row w-full justify-between mt-2 text-sm text-gray-500'>
              <span>Helper text</span>
              <span>0/100</span>
            </div>
          </div>
        </div>
      </div>

      <div className='hidden min-[1600px]:flex w-full justify-end'>
        <img
          src={TouchSide}
          alt='touchSide'
          className='h-[500px] mt-44'
        />
      </div>
    </div>
  )
}

export default ContactSection
